import classnames from 'classnames';
import * as React from 'react';

import styles from './teamCard.module.scss';

type PropsT = {
  children: React.ReactNode;
  className?: string;
};

export class Content extends React.PureComponent<PropsT> {
  static displayName: string;
  render() {
    const { children, className, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.contentTeam]: true,
      },
      className,
    );

    return (
      <ul {...otherProps} className={rootClass}>
        {children}
      </ul>
    );
  }
}

Content.displayName = 'Content';
